import { useRouter } from 'next/router';

import { matchPath } from '@kc-console/core';

import type { BreadcrumbItemData } from '@kc-console/common-ui';
import type { RouterConfig } from './types';

const useBreadcrumbItems = ({ routerConfig }: { routerConfig: RouterConfig }) => {
  const { asPath } = useRouter();

  const [pathname = ''] = asPath.split('?');

  const items: BreadcrumbItemData[] = [];
  let accumulatedPath = '';

  const segments = pathname.split('/').slice(1);

  for (let i = 0; i < segments.length; i++) {
    accumulatedPath += `/${segments[i]}`;

    for (const route of Object.keys(routerConfig)) {
      if (matchPath(accumulatedPath, route)) {
        items.push({ label: routerConfig[route], href: accumulatedPath });
        break;
      }
    }
  }

  // last item doesn't need href
  delete items.at(-1)?.href;

  return { items: items.filter(item => item.label !== '') };
};

export default useBreadcrumbItems;
